// Central bootstrap for Day.js plugins.
//
// Imported once from `src/index.js` (before any call site that uses Day.js
// features beyond the core) and re-exported so tests can import the
// already-configured `dayjs` without worrying about plugin ordering.
//
// - `utc` + `timezone`: required for `dayjs.tz(value, "Africa/Johannesburg")`
//   and `.utc()` chainables. Migrated from moment-timezone in PR 5.5.
// - `customParseFormat`: lets `dayjs(str, ISO_DATE_FORMAT, true)` accept a
//   bare day and reject anything else, rather than relying on ISO inference —
//   which parses a timestamp's first ten characters and drops the rest.
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export default dayjs;
